import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
} from "reactstrap";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import { connect } from "react-redux";
import * as actionCreators from "../../../modules/actions";
import { profilePicValidityCheck } from "../../../utils/constants";
import {
  LayoutData,
  LayoutHeading,
  LayoutRow,
} from "../../weekly-wins/TableLayoutComponents";
import { BiMailSend } from "react-icons/bi";
import { MdOutlineMobileFriendly } from "react-icons/md";
import moment from "moment";
import { isMobile } from "../../../utils/deviceInfo";
import CheckBox from "rc-checkbox";
import { withRouter } from "react-router";

const ManualRemindersModal = ({
  open,
  onClose,
  triviaData,
  user,
  ...props
}) => {
  const [usersToRemind, setUsersToRemind] = useState([]);
  const [sendViaEmail, setSendViaEmail] = useState(false);
  const [sendViaSMS, setSendViaSMS] = useState(false);
  const [usersLoading, setUsersLoading] = useState(false);
  const [showLimitSMSAlert, setShowLimitSMSAlert] = useState({
    display: false,
    totalSMS: 0,
    remainingLimit: 0,
  });
  const [allowSendLimitSMS, setAllowSendLimitSMS] = useState(false);

  useEffect(() => {
    setUsersLoading(true);
    axios
      .get(url.getUsersToRemind(triviaData._id))
      .then(({ data }) => {
        setUsersLoading(false);
        const remindUsers = data.data;
        setUsersToRemind(remindUsers);
      })
      .catch((err) => {
        setUsersLoading(true);
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (allowSendLimitSMS == true) {
      handleSendReminders();
    }
  }, [allowSendLimitSMS]);

  const handleSendReminders = () => {
    const payload = {
      sendViaEmail,
      sendViaSMS,
      usersToRemind,
      triviaId: triviaData._id,
    };

    const orgObject = user.profile.organizationId;

    const remainingSMS = orgObject.smsLimit - orgObject.totalSmsSent;

    const users_share_sms = usersToRemind.filter((x) => x.mobileNumber);

    if ( sendViaSMS && remainingSMS < users_share_sms.length && !allowSendLimitSMS) {
      setShowLimitSMSAlert({
        display: true,
        totalSMS: users_share_sms.length,
        remainingLimit: remainingSMS,
      });
      return;
    }

    axios
      .post(url.sendTrivvyReminders, payload)
      .then(({ data }) => {
        const { emailsSent, smsSent } = data.data;

        toastContainer(
          `Congrats! Your trivvy reminder was sent.${
            emailsSent > 0 ? ` Emails sent - ${emailsSent}` : ""
          }${emailsSent > 0 && smsSent > 0 ? ", " : " "}${
            smsSent > 0 ? `SMS sent - ${smsSent}` : ""
          }`,
          "success"
        );

        if (smsSent) {
            if (props.orgChangeSuccess) {
              props.orgChangeSuccess({
                totalSmsSent:
                  user.profile.organizationId.totalSmsSent + smsSent,
              });
            }
          }

          onClose()
      })
      .catch((err) => {
        toastContainer("Error occured while sending reminders", "error");
      });
  };

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const viewMember = (u) => {
    let link = `/home/${user.profile.organizationId._id}/profile/${u.value}`;
    props.history.push(link);
  };

  const tableCols = {
    user: sendViaSMS ? 4 : 6,
    date: 4,

    phoneNumber: 2,
    sharedVia: 2,
  };

  const sendButtonDisbaled = ()=>{
      return usersToRemind.length ===0 || ( !sendViaEmail && !sendViaSMS)
  }
  return (
    <Modal isOpen={open} toggle={onClose}>
      <ModalHeader className={"trivia_modal_header_bg"} toggle={onClose}>
        Send Reminders
      </ModalHeader>
      <ModalBody className={"p-3"}>
      <b>Below users will get Reminder notifications:</b>
        <div className="shareTableTrivia ml-2 font-13px">
        
          {!isMobile && (
            <LayoutRow className="mobileNoheightActionTable">
              <LayoutHeading
                className="border justify-content-center bg-white"
                colWidth={tableCols.user}
                plainTable
              >
                User
              </LayoutHeading>

              <LayoutHeading
                className="border justify-content-center bg-white"
                colWidth={tableCols.date}
                plainTable
              >
                Added On
              </LayoutHeading>

              {sendViaSMS ? (
                <LayoutHeading
                  className="border justify-content-center bg-white"
                  colWidth={tableCols.phoneNumber}
                  plainTable
                >
                  Mobile Number
                </LayoutHeading>
              ) : null}

              <LayoutHeading
                className="border justify-content-center bg-white"
                colWidth={tableCols.sharedVia}
                plainTable
              >
                Shared Via
              </LayoutHeading>
            </LayoutRow>
          )}

          <div
            style={{
              //   maxHeight:
              //     usersToRemind && usersToRemind.length > 0
              //       ? "300px"
              //       : "0px",
              //   overflowY: "auto",
              //   overflowX: "hidden",
              marginLeft: "-15px",
            }}
            className="hide-scroll w1scr"
          >
            {usersToRemind && usersToRemind.length > 0 ? (
              usersToRemind.map((item) => {
                console.log("itemmmmmmmmm____", item);
                if (isMobile) {
                  return (
                    <LayoutData fullWidth className="col-pl-0 d-block bg-white">
                      <div
                        style={{
                          alignItems: "center",
                          display: "flex",
                        }}
                        className="my-2 pl-2"
                      >
                        <div className="grp_member_profile_image cursor-pointer">
                          {profilePicValidityCheck(item.profilePic) ? (
                            <div className="list-item__avatar">
                              <img src={item.profilePic} />
                            </div>
                          ) : (
                            <span
                              className="list-item__avatar"
                              data-letters={
                                item.value == user.profile._id
                                  ? getInitials(user.profile)
                                  : getInitials(item)
                              }
                            ></span>
                          )}
                        </div>

                        <div className="">
                          <div
                            className="linkedToolView"
                            onClick={() => viewMember(item)}
                          >
                            {item.value == user.profile._id ? (
                              "You"
                            ) : (
                              <span>
                                {" "}
                                {item.firstName}
                                {item &&
                                item.lastName &&
                                item.lastName.length > 0
                                  ? `, ${item.lastName}`
                                  : null}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </LayoutData>
                  );
                } else {
                  return (
                    <LayoutRow className="ml-0 mr-0">
                      <LayoutData
                        colWidth={tableCols.user}
                        className="bg-white"
                      >
                        <div
                          style={{
                            alignItems: "center",
                            display: "flex",
                          }}
                          className="my-0 pl-2"
                        >
                          <div className="grp_member_profile_image cursor-pointer">
                            {profilePicValidityCheck(item.profilePic) ? (
                              <div className="list-item__avatar">
                                <img src={item.profilePic} />
                              </div>
                            ) : (
                              <span
                                className="list-item__avatar"
                                data-letters={
                                  item.value == user.profile._id
                                    ? getInitials(user.profile)
                                    : getInitials(item)
                                }
                              ></span>
                            )}
                          </div>

                          <div className="">
                            <div
                              className="linkedToolView"
                              onClick={() => viewMember(item)}
                            >
                              {item.value == user.profile._id ? (
                                "You"
                              ) : (
                                <span>
                                  {" "}
                                  {item.firstName}
                                  {item &&
                                  item.lastName &&
                                  item.lastName.length > 0
                                    ? `, ${item.lastName}`
                                    : null}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </LayoutData>

                      <LayoutData
                        colWidth={tableCols.date}
                        className="bg-white addedOnDateCss"
                      >
                        {moment(item.date).format("h:mma on MMM D, YYYY")}
                      </LayoutData>
                      {sendViaSMS ? (
                        <LayoutData
                          colWidth={tableCols.phoneNumber}
                          className="bg-white"
                        >
                          {item.mobileNumber && item.mobileNumber.length > 0
                            ? item.mobileNumber
                            : "No"}
                        </LayoutData>
                      ) : null}

                      <LayoutData
                        colWidth={tableCols.sharedVia}
                        className="bg-white"
                      >
                        {item.shareMediums && item.shareMediums.length ? (
                          <div className="trivvy-share-via-container">
                            {item.shareMediums.includes("EMAIL") && (
                              <div>
                                <BiMailSend
                                  size={"17px"}
                                  style={{ marginRight: "3px" }}
                                />
                                {/* <span className="font-13px">Emailed on {item.emailDate ?moment(item.emailDate).format("MM/DD/YYYY"):moment(item.date).format("MM/DD/YYYY")}</span>  */}
                                <span className="font-13px">
                                  {item.emailDate
                                    ? moment(item.emailDate).format(
                                        "MM/DD/YYYY"
                                      )
                                    : ""}
                                </span>
                              </div>
                            )}
                            {item.shareMediums.includes("SMS") && (
                              <div>
                                <MdOutlineMobileFriendly size={"14px"} />
                                {/* <span className="font-13px">SMS on {item.smsDate ? moment(item.smsDate).format("MM/DD/YYYY"):moment(item.date).format("MM/DD/YYYY")}</span>  */}
                                <span className="font-13px">
                                  {" "}
                                  {item.smsDate
                                    ? moment(item.smsDate).format("MM/DD/YYYY")
                                    : ""}
                                </span>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </LayoutData>
                    </LayoutRow>
                  );
                }
              })
            ) : (
              <div className="my-2 ml-5" style={{fontSize:"18px"}}>
                {usersLoading ? "Loading..." : "No trivvy shared with users"}
              </div>
            )}
          </div>
        </div>

        {usersToRemind && usersToRemind.length > 0 ? (
          <div className="my-3 d-flex">
            <b>Remind Via:</b>{" "}
            <div className="ml-2">
              <CheckBox
                checked={sendViaEmail}
                onChange={(e) => setSendViaEmail(e.target.checked)}
              />{" "}
              Link{" "}
            </div>{" "}
            <div className="ml-2">
              <CheckBox
                checked={sendViaSMS}
                onChange={(e) => setSendViaSMS(e.target.checked)}
              />{" "}
              SMS{" "}
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="mt-4">
          {showLimitSMSAlert && showLimitSMSAlert.display ? (
            <Alert style={{ backgroundColor: "rgb(212 233 237 / 75%)" }}>
              {showLimitSMSAlert.remainingLimit ? (
                <span>
                  You have only {showLimitSMSAlert.remainingLimit} SMS left and
                  you are sending {showLimitSMSAlert.totalSMS} SMS, So only
                  first {showLimitSMSAlert.remainingLimit} will recieve SMS
                  notifications. Do you want to continue?
                </span>
              ) : (
                <span>
                  You have only {showLimitSMSAlert.remainingLimit} SMS left and
                  you are sending {showLimitSMSAlert.totalSMS} SMS, So no one
                  will recieve SMS notifications. Do you want to continue?
                </span>
              )}

              <div className="mt-3">
                <Button
                  color="success"
                  onClick={() => {
                    setAllowSendLimitSMS(true);
                  }}
                >
                  Continue
                </Button>{" "}
                <Button
                  onClick={() => {
                    setShowLimitSMSAlert({
                      display: false,
                      remainingLimit: 0,
                      totalSMS: 0,
                    });
                  }}
                  className="ml-3"
                  color="danger"
                >
                  Cancel
                </Button>
              </div>
            </Alert>
          ) : (
            ""
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button disabled={sendButtonDisbaled()} className="trivia-action-button-main"  onClick={handleSendReminders}>
          Send Reminders
        </Button>
        <Button style={{height:"33px"}} color="secondary" onClick={onClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ManualRemindersModal));
